import { render, staticRenderFns } from "./PaoStructureMenu.vue?vue&type=template&id=7ef18674&scoped=true"
import script from "./PaoStructureMenu.vue?vue&type=script&lang=js"
export * from "./PaoStructureMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef18674",
  null
  
)

export default component.exports